import { Box, Typography } from '@mui/material'
import { ActivityMark } from './typing'
import { useStyles } from './styles'
import { useState } from 'react'
import { CaptionKeyVertical } from '../detailKeyValue/keyCaption.index'
import { useTranslation } from 'react-i18next'
import { getStatus } from '../../hooks/status'
import { useContextState } from '../../hooks/theme'
import StatusComponent from '../status'
import { getType } from '../../pages/logbook/pages/main/utils/methods/getTypeActivity'
import { PointType } from '../../pages/logbook/pages/main/utils/enums/pointType'
import { icons } from '../../utils/icons'
import { Status } from '../../utils/enums'
import { ActivityOnMap } from '../../pages/logbook/pages/main/components/shared/activityOnMap'

const MapMarkerActivity = ({ Node, ...props }: ActivityMark) => {
  const { t } = useTranslation()
  const { colors } = useContextState()
  const { title, userName, status, startDate, children, endDate, unityLocation, isCenter, isDetination, count, finishLocation, initLocation, storeAndId, isForceClose, endProgramed, startProgramed, type } = props
  const { text, color } = getStatus(status ?? Status.TO_BE_STARTED, colors, t)
  const styles = useStyles()
  const [showTooltip, setShowTooltip] = useState(false)
  const isNoFinisf = status === Status.NOT_FINISHED ? true : false;
  const colorNoFinish = colors.color13
  const [latUnity, lngUnity] = unityLocation.split(',').map(String);
  const [latInit, lngInit] = initLocation.split(',').map(String);
  const [latFinish, lngFinish] = finishLocation.split(',').map(String);
  const [openSeeMore, setOpenSeeMore] = useState(false);
  const closeOrViewLess = () => {
    setOpenSeeMore(false)
    setShowTooltip(false)
  }
  const getTitle = () => {
    let title = '';
    switch (type) {
      case PointType.END:
        title = t('loogbook.pointTitle.end')
        break
      case PointType.START:
        title = t('loogbook.pointTitle.start')
        break
      case PointType.UNITY:
        title = t('loogbook.pointTitle.unity')
        break
      case PointType.UNITYT_START_END:
        title = t('loogbook.pointTitle.unity_start_end')
        break
      case PointType.UNITY_END:
        title = t('loogbook.pointTitle.unity_end')
        break
      case PointType.UNITY_START:
        title = t('loogbook.pointTitle.unity_start')
        break
      case PointType.START_END:
        title = t('loogbook.pointTitle.start_end')
        break
      default:
        title = t('loogbook.pointTitle.unity_start_end')
    }
    return title;
  }
  return (
    <Box sx={[styles.relative]} onMouseOut={() => setShowTooltip(false)} onMouseOver={() => setShowTooltip(true)}>
      {showTooltip && (
        <Box sx={[styles.flex, styles.containerTooltip, styles.padding]}>
          <Box sx={styles.labelContainer}>
            <Typography sx={styles.titlePoint(/* (type == PointType.END && !isCenter) || (type == PointType.START && !isCenter) || */(type == PointType.START_END && isForceClose) || (type == PointType.UNITYT_START_END && isForceClose) || (type == PointType.END && isForceClose) || (type == PointType.UNITY_END && isForceClose))} variant='text_grey' fontWeight='bold' fontSize={16}>{getTitle()}</Typography>

            {/* <StatusComponent color={color} msg={text} fit type='chip' size='xs' /> */}
            <StatusComponent color={isNoFinisf ? colorNoFinish : color} msg={text} type="chip" size="xs" fit />
          </Box>

          {type !== PointType.UNITY && <Typography variant='text_grey' fontWeight='bold' fontSize={16}>{title}</Typography>}

          <Box sx={styles.flex}>
            {type == PointType.UNITY && <CaptionKeyVertical caption={t('loogbook.storeId')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={storeAndId || 'N/A'} />}

            {type == PointType.UNITY && <CaptionKeyVertical caption={t('loogbook.location')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={unityLocation ? `Lat: ${latUnity}, Lon: ${lngUnity}` : 'N/A'} />}

            {type == PointType.UNITY && count > 1 &&
              <Box sx={styles.seeMoreContainer}>
                <Typography variant='text_grey' fontWeight='bold'>{!isDetination ? t('loogbook.countActivitiesDestination', { count: count }) : t('loogbook.countActivities', { count: count })}</Typography>
                <Typography sx={styles.mapLink} onClick={() => { setOpenSeeMore(true) }} variant="text_grey" fontWeight='500' >{t('loogbook.buttons.seeMore')}</Typography>
              </Box>
            }

            {type !== PointType.UNITY && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.programationType')}: `} value={getType(props.isFree, t)} />}

            {type !== PointType.UNITY && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('general.assignedUser')}: `} value={userName || 'N/A'} />}

            {type !== PointType.UNITY && <CaptionKeyVertical caption={t('loogbook.storeId')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={storeAndId || 'N/A'} />}

            {type !== PointType.UNITY && startProgramed && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={startProgramed || 'N/A'} />}

            {type !== PointType.UNITY && endProgramed && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endProgramed || 'N/A'} />}
          </Box>

          {type !== PointType.UNITY && <Box sx={styles.flex}>
            <Typography sx={styles.titles} variant="text_grey" fontWeight='bold' fontSize={14}>{t('loogbook.titles.execution')}</Typography>
            {(type == PointType.UNITYT_START_END || type == PointType.UNITY_END || type == PointType.START_END || type == PointType.END) && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.titles.closeType')}: `} value={isForceClose ? <Typography sx={styles.error} variant="text_grey" fontWeight='500'>{icons('info')}{t('loogbook.titles.forced')}</Typography> : <Typography variant="text_grey" fontWeight='500'>{t('loogbook.titles.normal')}</Typography>} />}

            {(type == PointType.UNITYT_START_END) && <CaptionKeyVertical caption={t('loogbook.location')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={unityLocation ? `Lat: ${latUnity}, Lon: ${lngUnity}` : 'N/A'} />}

            {(type == PointType.UNITY_START) && <CaptionKeyVertical caption={t('loogbook.startLocation')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={unityLocation ? `Lat: ${latUnity}, Lon: ${lngUnity}` : 'N/A'} />}

            {(type == PointType.UNITY_END) && <CaptionKeyVertical caption={t('loogbook.endLocation')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={unityLocation ? `Lat: ${latUnity}, Lon: ${lngUnity}` : 'N/A'} />}

            {(type == PointType.START) && <CaptionKeyVertical caption={t('loogbook.startLocation')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={initLocation ? `Lat: ${latInit}, Lon: ${lngInit}` : 'N/A'} />}

            {(type == PointType.END) && <CaptionKeyVertical caption={t('loogbook.endLocation')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={finishLocation ? `Lat: ${latFinish}, Lon: ${lngFinish}` : 'N/A'} />}

            {(type == PointType.START_END) && <CaptionKeyVertical caption={t('loogbook.location')} captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} value={finishLocation ? `Lat: ${latFinish}, Lon: ${lngFinish}` : 'N/A'} />}

            {(type == PointType.UNITY_START || type == PointType.UNITYT_START_END || type == PointType.START || type == PointType.START_END) && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.titles.startDate')}: `} value={startDate || 'N/A'} />}

            {(type == PointType.UNITY_END || type == PointType.UNITYT_START_END || type == PointType.END || type == PointType.START_END) && <CaptionKeyVertical captionProps={{ sx: { width: '39%' } }} valueProps={{ sx: { width: '59%' } }} caption={`${t('loogbook.titles.endDate')}: `} value={endDate || 'N/A'} />}
          </Box>}
        </Box>
      )}

      <Box sx={styles.userPoint} >
        {Node && <Node />}
      </Box>

      {openSeeMore && <ActivityOnMap closeOrViewLess={closeOrViewLess} children={children ?? []} openSeeMore={openSeeMore}/>}
    </Box>
  )
}

export { MapMarkerActivity }